export enum EDruhCertifikatu {
    PAKOVY = 'PAKOVY',
    NEPAKOVY = 'NEPAKOVY'
}
